(() => {
  if (window.neliCartSavings) return;
  const source = document.querySelector('[data-neli-savings-data]');
  if (!source) return;
  let data;
  try { data = JSON.parse(source.textContent); } catch (_) { return; }
  window.neliCartSavings = true;
  const signature = cart => JSON.stringify([
    cart.currency, cart.total_price, cart.original_total_price,
    (cart.items || []).map(item => [item.key, item.quantity, item.original_line_price, item.final_line_price])
  ]);
  let currentSignature = signature(data);
  let wantedSignature = currentSignature;
  let requestNumber = 0;
  let controller;
  let mountQueued = false;
  const ownSelector = '[data-neli-savings-owned]';
  const priceSelector = '.qsc2-drawer-footer__summary-subtotal-price';
  const setText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  const create = (tag, className) => {
    const node = document.createElement(tag);
    node.className = className;
    node.setAttribute('data-neli-savings-owned', '');
    return node;
  };
  const reset = drawer => {
    drawer.removeAttribute('data-neli-savings-ready');
    drawer.querySelectorAll(ownSelector).forEach(node => node.remove());
    drawer.querySelectorAll('[data-neli-savings-ready]').forEach(node => node.removeAttribute('data-neli-savings-ready'));
  };
  function mount() {
    mountQueued = false;
    document.querySelectorAll('.qsc2-drawer').forEach(drawer => {
      if (currentSignature !== wantedSignature || !data.items.length || data.savings <= 0) {
        reset(drawer);
        return;
      }
      const subtotal = drawer.querySelector('.qsc2-drawer-footer__summary-subtotal');
      if (!subtotal) return;
      let row = drawer.querySelector('.neli-cart-savings-row');
      if (!row) {
        row = create('div', 'qsc2-drawer-footer__row neli-cart-savings-row');
        row.append(create('span', 'neli-cart-savings-label'), create('span', 'neli-cart-savings-value'));
        subtotal.before(row);
      }
      setText(row.firstElementChild, data.label);
      setText(row.lastElementChild, '−' + data.savingsMoney);
      if (!drawer.hasAttribute('data-neli-savings-ready')) drawer.setAttribute('data-neli-savings-ready', '');
      const price = drawer.querySelector(priceSelector);
      if (price) {
        let reference = price.querySelector('.neli-cart-savings-reference');
        if (!reference) {
          reference = create('s', 'neli-cart-savings-reference');
          price.prepend(reference);
        }
        setText(reference, data.referenceMoney);
        if (!price.hasAttribute('data-neli-savings-ready')) price.setAttribute('data-neli-savings-ready', '');
      }
    });
  }
  function queueMount() {
    if (mountQueued) return;
    mountQueued = true;
    requestAnimationFrame(mount);
  }
  async function sync(cart) {
    const nextSignature = signature(cart);
    if (nextSignature === wantedSignature && (controller || nextSignature === currentSignature)) {
      queueMount();
      return;
    }
    wantedSignature = nextSignature;
    if (controller) controller.abort();
    if (nextSignature === currentSignature) { controller = null; queueMount(); return; }
    const number = ++requestNumber;
    controller = new AbortController();
    queueMount();
    try {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(root, location.origin);
      url.searchParams.set('section_id', 'neli-cart-savings');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Savings unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = JSON.parse(html.querySelector('[data-neli-savings-data]').textContent);
      if (number !== requestNumber || signature(fresh) !== wantedSignature) return;
      data = fresh;
      currentSignature = wantedSignature;
      queueMount();
    } catch (_) {
      // Keep the application's own prices if the fresh comparison cannot be loaded.
    } finally {
      if (number === requestNumber) controller = null;
    }
  }
  document.addEventListener('neli:cart:read', event => sync(event.detail));
  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => {
      const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (target?.closest(ownSelector + ', .neli-free-shipping-goal')) return false;
      const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
      if (nodes.length && nodes.every(node => node.nodeType === 1 && node.matches(ownSelector))) return false;
      return target?.closest('.qsc2-drawer') || nodes.some(node => node.nodeType === 1 && (node.matches('.qsc2-drawer') || node.querySelector('.qsc2-drawer')));
    })) queueMount();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  mount();
})();
